let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3L482")).then(() => parcelRequire('faXq4'));